var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueTriangleWorkflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 9L-7.86805e-07 18L0 -9.17939e-07L21 9Z",
    fill: "#E3F0FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueTriangleWorkflow);
export default __webpack_public_path__ + "static/media/blueTriangleWorkflow.7052a711efd37fd8865e72243c86da02.svg";
export { ForwardRef as ReactComponent };